import React from 'react';
import {
  StudentStatusEnum,
  studentType,
} from '../../../constants/types/student-type';
import TextWinds from '../../common/TextWinds';
import StudentConroller from './StudentController';
import HFbutton from '../../button/HFbutton';
import {
  CheckBadgeIcon,
  TrashIcon,
  UserGroupIcon,
} from '@heroicons/react/24/outline';
import { UserMinusIcon } from '@heroicons/react/20/solid';

interface StudentStateControlProps {
  status: StudentStatusEnum;
  studentList: studentType[];
  reloadTable: () => void;
  controller: StudentConroller;
}
const StudentStateControl = ({
  status,
  studentList,
  controller,
}: StudentStateControlProps) => {
  return (
    <div>
      <div className="flex justify-end gap-x-[22px] py-2">
        <div className="flex items-center gap-x-3">
          <TextWinds type="content_body4" color="gray7" className="w-[68px]">
            {studentList.length}명 선택됨
          </TextWinds>
        </div>
        <div className="flex gap-x-2">
          {status === StudentStatusEnum.ACTIVE && (
            <HFbutton
              type="red-outlined"
              width="auto"
              height={40}
              onClick={() => controller.assignHandler(studentList)}
              disabled={studentList.length === 0}
            >
              <span className="flex items-center justify-center whitespace-nowrap text-sm">
                <UserGroupIcon className="mr-2 h-5 w-5 shrink-0" />
                반 배정
              </span>
            </HFbutton>
          )}
          {status === StudentStatusEnum.ACTIVE && (
            <HFbutton
              type="orange-filled"
              width="auto"
              height={40}
              onClick={() => controller.stopHandler(studentList)}
              disabled={studentList.length === 0}
            >
              <span className="flex items-center justify-center whitespace-nowrap text-sm">
                <UserMinusIcon className="mr-2 h-5 w-5 shrink-0" />
                수강 정지
              </span>
            </HFbutton>
          )}
          {(status === StudentStatusEnum.INACTIVE ||
            status === StudentStatusEnum.PENDING) && (
            <HFbutton
              type="primary-filled"
              width="auto"
              height={40}
              onClick={() => controller.registHandler(studentList)}
              disabled={studentList.length === 0}
            >
              <span className="flex items-center justify-center whitespace-nowrap text-sm">
                <CheckBadgeIcon className="mr-2 h-5 w-5 shrink-0" />
                수강 등록
              </span>
            </HFbutton>
          )}
          {(status === StudentStatusEnum.INACTIVE ||
            status === StudentStatusEnum.PENDING) && (
            <HFbutton
              type="red-outlined"
              width="auto"
              height={40}
              onClick={() => controller.deleteHandler(studentList)}
              disabled={studentList.length === 0}
            >
              <span className="flex items-center justify-center whitespace-nowrap text-sm">
                <TrashIcon className="mr-2 h-5 w-5 shrink-0" />
                학생 삭제
              </span>
            </HFbutton>
          )}
        </div>
      </div>
    </div>
  );
};

export default StudentStateControl;
